import React from 'react'
import { useNavigate } from 'react-router-dom'

// For We Can&apos;t See

const GiveHopeContainer = () => {
  const navigate = useNavigate()
  const movePage = (text) => {
    navigate(text)
  }

  return (
    <div className='flex-auto h-[320px] flex gap-10 bg-inherit text-slate-100'>
      <div className='flex-auto h-full flex '>
        <h1 className='flex text-end text-6xl h-fit my-auto ml-auto mr-56 pb-12 flex-col gap-1 pt-4'>
          <span className='inline-block'>Give Hope</span>
          <span className='inline-block'>To Those In Need</span>
        </h1>
      </div>
      <div className='flex-auto min-w-fit flex flex-col m-auto gap-4 pb-5'>
        <h3 className='flex-end my-auto text-lg'>
          Get more information about <b>GIVU</b>.
        </h3>
        <div className='flex-auto flex gap-3'>
          <button
            className='px-6 py-4 bg-inherit hover:bg-pastel-yellow text-[#f9fafb] border border-[#f9fafb] hover:border-[#FDFD96] hover:shadow-lg transition-all duration-300 hover:duration-300 hover:text-[#0f0f0f]'
            onClick={() => movePage('how-it-works')}
          >
            How it works
          </button>
          <button
            className='px-6 py-4 bg-[#f9fafb] hover:bg-pastel-yellow text-[#0f0f0f] border-[#f9fafb] hover:border-[#FDFD96] border transition-all duration-300 hover:duration-300'
            onClick={() => movePage('sign-up')}
          >
            Sign Up
          </button>
        </div>
      </div>
    </div>
  )
}

export default GiveHopeContainer
